type MfaSessionState = {
  isMfaEnabled: boolean;
  authenticatorAssuranceLevel: 'aal1' | 'aal2';
};

export function shouldRequireAdditionalAuth(
  session: MfaSessionState | null | undefined,
): boolean {
  if (!session) return false;
  return session.isMfaEnabled && session.authenticatorAssuranceLevel === 'aal1';
}
